<template>
<div>
  Showcase
</div>
</template>

<script>
export default {
  name: "Showcase"
}
</script>

<style scoped>

</style>
